import {ISSUES} from '../content/issues';
import {OUTLETS} from '../content/parties';
import {toast} from './govern';
import {press} from './media';
import {choice,rnd} from './rng';
import {S,log} from './state';
import {issuesNow} from './axes';

export function issueLifecycle(){
  let att=false;
  issuesNow().forEach((i:any)=>{const st=S.issues[i.id];
    if(st.on&&!st.law&&st.sev<20){st.low=(st.low||0)+1;if(st.low>=3){st.on=false;st.solved=S.m;st.low=0;att=true;
      log(`Problem gelöst: ${i.n} spielt politisch keine Rolle mehr.`,'good');press(OUTLETS[0].n,`Erfolg für die Regierung: ${i.n} ist kein Thema mehr`,1);toast(`Gelöst: ${i.n}`,'good')}}
    else st.low=0;
    if(!st.on&&st.solved!=null&&S.m-st.solved>12&&rnd()<.01*(1-st.cut)){st.on=true;st.solved=null;st.sev=Math.max(st.sev,32+rnd()*10);att=true;
      log(`Das Problem kehrt zurück: ${i.n}.`,'bad');toast(`Zurück auf der Agenda: ${i.n}`,'bad')}
  });
  const active=issuesNow().filter((i:any)=>S.issues[i.id].on).length;
  const latent=issuesNow().filter((i:any)=>i.at==null&&!S.issues[i.id].on&&S.issues[i.id].solved==null);
  if(latent.length&&active<19&&rnd()<.1){const i=choice(latent),st=S.issues[i.id];st.on=true;st.sev=i.sev+rnd()*8-4;att=true;
    log(`Neues Problem auf der Agenda: ${i.n}.`,'bad');toast(`Neues Problem: ${i.n}`,'bad');press(choice(OUTLETS).n,`${i.n}: ${i.d.split('.')[0]}`,-.5)}
  return att;
}
